import { all, fork } from "redux-saga/effects";
import authSagas from "./authSagas";
import { onMessageFromEventListenerSaga } from "./WebSocketSagas";

export default function* rootSaga() {
  yield all([
    fork(authSagas),
    fork(onMessageFromEventListenerSaga),
  ]);
}
